import * as React from "react";
import type { SVGProps } from "react";
const SvgLoadingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="loading_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M373.077 200.235a341.333 341.333 0 1 1-202.41 311.978v-35.328a42.667 42.667 0 0 0-85.334 0v35.328a426.71 426.71 0 0 0 784.598 232.022 426.667 426.667 0 0 0-531.584-621.952 42.667 42.667 0 0 0 34.73 77.952z"
    />
  </svg>
);
export default SvgLoadingIcon;
